export default "__VITE_ASSET__4b472df4__"